import { render, staticRenderFns } from "./CircularScore.vue?vue&type=template&id=0bc95b5a&scoped=true&"
import script from "./CircularScore.vue?vue&type=script&lang=js&"
export * from "./CircularScore.vue?vue&type=script&lang=js&"
import style0 from "./CircularScore.vue?vue&type=style&index=0&id=0bc95b5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc95b5a",
  null
  
)

export default component.exports